/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sch_Level_1_HintInputs */

const en_sch_level_1_hint = /** @type {(inputs: Sch_Level_1_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everyday work such as tasks, bugs and features. Can sit under epics and initiatives.`)
};

const de_sch_level_1_hint = /** @type {(inputs: Sch_Level_1_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alltägliche Arbeit wie Aufgaben, Fehler und Features. Kann unter Epics und Initiativen stehen.`)
};

/**
* | output |
* | --- |
* | "Everyday work such as tasks, bugs and features. Can sit under epics and initiatives." |
*
* @param {Sch_Level_1_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sch_level_1_hint = /** @type {((inputs?: Sch_Level_1_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sch_Level_1_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_sch_level_1_hint(inputs)
	return en_sch_level_1_hint(inputs)
});